import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import {
  TerminalDataModel,
  TranslationsLibService,
} from '@nutricontrol/app360-shared';
import { FormGroup } from '@angular/forms';
import { ReportsService } from '../../reports.service';
import { TerminalCurrencyDataModel } from '../../reports.model';

@Component({
  selector: 'app-terminal-selector',
  templateUrl: './terminal-selector.component.html',
  styleUrls: ['./terminal-selector.component.scss'],
})
export class TerminalSelectorComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() terminals: TerminalDataModel[];
  @Output() terminalSelected = new EventEmitter<TerminalDataModel>();
  @Output() terminalCurrency = new EventEmitter<TerminalCurrencyDataModel>();

  terminal?: TerminalDataModel;
  terminalsGroupedByField: { [key: string]: TerminalDataModel[] } = {};
  terminalsWithoutField: TerminalDataModel[] = [];

  constructor(
    public translationsLib: TranslationsLibService,
    private reportsService: ReportsService
  ) {}

  ngOnInit(): void {
    this.groupTerminals();
  }

  groupTerminals() {
    for (const terminal of this.terminals) {
      if (terminal.field === null) {
        this.terminalsWithoutField.push(terminal);
      } else {
        if (!this.terminalsGroupedByField[terminal.field.name]) {
          this.terminalsGroupedByField[terminal.field.name] = [];
        }
        this.terminalsGroupedByField[terminal.field.name].push(terminal);
      }
    }
  }

  onTerminalChange(terminal: TerminalDataModel) {
    this.terminal = terminal;
    this.reportsService.getTerminalCurrency(terminal.vid).subscribe(
      (terminalCurrency) => {
        this.terminalCurrency.emit(terminalCurrency);
      },
      (error) => {
        console.error(error);
      }
    );
    this.terminalSelected.emit(terminal);
  }

  getGroupedFieldNames(): string[] {
    return Object.keys(this.terminalsGroupedByField);
  }
}
